import React from 'react';
import { Table as OriginalTable } from 'antd';
const Table = (props) => {
    const columns = (props.columns || []).filter((item) => !item?.hidden);
    return React.createElement(OriginalTable, Object.assign({}, props, { columns: columns }));
};
export default Table;
